import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { ControlLockMode } from '@src/types/ControlLockMode';

export default (deviceId: string | undefined) => {
  return useApiQuery<ControlLockMode>({
    queryKey: [QueryKeys.controllerLockMode, deviceId || ''],
    apiPath: `/controls-lock/${deviceId}/current`,
    method: 'GET',
    useV2API: true,
  });
};
